// extracted by mini-css-extract-plugin
export default {"adminLayout_logo":"SideBar_adminLayout_logo__5J9Jz","sidebar_container":"SideBar_sidebar_container__O87aX","sidebar_container_long_text":"SideBar_sidebar_container_long_text__obdNx"};